// extracted by mini-css-extract-plugin
module.exports = {"fullscreen":"BBHTML_fullscreen__1o7ls","fullwindow":"BBHTML_fullwindow__1g-Mm"};